/**
 * Public help hub.
 * @viewport both
 */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Chip, Paper, Stack, Typography, Button } from '@mui/material';
import HelpPublicLayout from '@/features/help/components/HelpPublicLayout';
import {
  AUTH_HELP_CATEGORIES,
  AUTH_HELP_FAQ,
  AUTH_HELP_PATHS,
  AUTH_HELP_SUPPORT_EMAIL,
} from '@/features/help/helpContent';

const HelpHubPage = () => (
  <HelpPublicLayout
    title="Getting started on HFRConnect"
    subtitle="Answers about signing up as a Firm Manager or Allocator, participation, and account approval."
  >
    <Paper variant="outlined" sx={{ p: 2.5, borderRadius: 2, mb: 3 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        Frequently asked questions
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {AUTH_HELP_FAQ.length} answers about registration, roles, participation, and onboarding.
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mb: 2 }}>
        {AUTH_HELP_CATEGORIES.map((category) => (
          <Chip key={category} label={category} size="small" variant="outlined" />
        ))}
      </Stack>
      <Button component={RouterLink} to={AUTH_HELP_PATHS.faq} variant="contained" size="small">
        Browse FAQ
      </Button>
    </Paper>

    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="body2" color="text.secondary">
        Still need help?{' '}
        <Typography
          component="a"
          href={`mailto:${AUTH_HELP_SUPPORT_EMAIL}`}
          variant="body2"
          color="primary"
        >
          {AUTH_HELP_SUPPORT_EMAIL}
        </Typography>
      </Typography>
    </Box>
  </HelpPublicLayout>
);

export default HelpHubPage;
